'use client';

import { UIPriority } from '@/enums/ui-priorities';
import Button from '@/ui/Button';
import { ActionButtonsButtonRowBindings } from '@/components/action-buttons/action-buttons-view.types';
import { SelectionCountBubble } from '@/components/table-selection/TableSelectionHeaderControls';
import { QuotaActionButton, QuotaTopUpButton } from '@/components/billing/QuotaTopUpButton';

export const ActionButtonsButtonRow = (props: ActionButtonsButtonRowBindings) => {
    const openReviewReplyFlow = () => {
        if (props.pickedReviewsCount > 0) {
            props.setIsAnswerModalOpen(true);
            return;
        }

        props.setIsAiModalOpen(true);
    };

    return (
        <>
            {props.showAccountTopUpButton ? (
                <QuotaTopUpButton
                    reason={props.replyDisabledReason}
                    tooltipClassName="inline-flex"
                    className="max-w-40 px-2 w-fit whitespace-nowrap !min-h-[30px] !py-0.5"
                />
            ) : null}
            {props.isReviewsTable && (
                <QuotaActionButton
                    reason={props.replyDisabledReason}
                    isQuotaExhausted={props.isReplyQuotaExhausted}
                    tooltipClassName="inline-flex"
                    className="max-w-40 px-2 w-fit whitespace-nowrap !min-h-[30px] !py-0.5"
                    priorityType={props.reviewsSelectionPriority}
                    uiSize="compact"
                    onClick={openReviewReplyFlow}
                    disabled={props.isReplyDisabled}
                >
                    Ответить
                </QuotaActionButton>
            )}
            {(props.isReviewsTable || props.isGroupTable) && props.isAiAnalysisLoading && (
                <Button
                    className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px] disabled:opacity-50"
                    priorityType={UIPriority.SECONDARY}
                    uiSize="compact"
                    onClick={props.onCancelAiAnalysis}
                >
                    Отмена ИИ
                </Button>
            )}
            {props.isGroupTable && (
                <Button
                    className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px] disabled:opacity-50"
                    priorityType={props.groupSelectionPriority}
                    uiSize="compact"
                    onClick={props.onOpenCombinedAnalysis}
                    disabled={props.isCombinedAnalysisForGroupDisabled}
                >
                    {props.isCombinedAnalysisLoading ? 'График...' : 'График'}
                </Button>
            )}
            {props.isGroupTable && (
                <Button
                    className="w-36 max-w-36 whitespace-nowrap !min-h-[30px] !p-[5px] disabled:opacity-50"
                    priorityType={props.mergePriority}
                    uiSize="compact"
                    onClick={props.activeTable === 'brands' ? props.onGroupPickedBrands : props.onGroupPickedProducts}
                    disabled={props.isMergeActiveGroupDisabled}
                >
                    {props.isGroupsMergeLoading ? 'Группируем...' : 'Группировать'}
                </Button>
            )}
            {props.hasActiveAnswerJobs && (
                <Button
                    className="w-36 max-w-36 whitespace-nowrap !min-h-[30px] !p-[5px] disabled:opacity-50"
                    priorityType={UIPriority.SECONDARY}
                    uiSize="compact"
                    onClick={props.onCancelActiveAnswerJobs}
                    disabled={props.isAnswerJobsCancelLoading}
                >
                    {props.isAnswerJobsCancelLoading ? 'Отменяем...' : 'Отменить ответы'}
                </Button>
            )}
            <Button
                className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px]"
                priorityType={props.activeTable === 'products' ? UIPriority.PRIMARY : UIPriority.SECONDARY}
                uiSize="compact"
                onClick={() => props.onSetActiveTable('products')}
            >
                Продукты
            </Button>
            <Button
                className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px]"
                priorityType={props.activeTable === 'brands' ? UIPriority.PRIMARY : UIPriority.SECONDARY}
                uiSize="compact"
                onClick={() => props.onSetActiveTable('brands')}
            >
                Бренды
            </Button>
            <Button
                className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px]"
                priorityType={props.activeTable === 'reviews' ? UIPriority.PRIMARY : UIPriority.SECONDARY}
                uiSize="compact"
                onClick={() => props.onSetActiveTable('reviews')}
            >
                Отзывы
            </Button>
            <Button
                className="w-28 max-w-28 whitespace-nowrap !min-h-[30px] !p-[5px]"
                priorityType={
                    props.isReportModalOpen || props.selectedItemsCount > 0 ? UIPriority.PRIMARY : UIPriority.SECONDARY
                }
                uiSize="compact"
                onClick={() => props.setIsReportModalOpen(true)}
            >
                ИИ Отчет
            </Button>
            {props.isReviewsTable && (
                <div className="relative">
                    <Button
                        className="max-w-32 px-2 !min-h-[30px] !py-0.5"
                        priorityType={UIPriority.SECONDARY}
                        uiSize="compact"
                        onClick={props.onExportCsv}
                        disabled={props.isExportLoading}
                    >
                        {props.isExportLoading ? 'Экспорт...' : 'Экспорт'}
                    </Button>
                    {(props.pickedReviewsCount > 0 ||
                        (props.isSelectedItemsCountSyncing && props.isAllPickLoading)) && (
                        <SelectionCountBubble
                            count={props.pickedReviewsCount}
                            isSyncing={props.isSelectedItemsCountSyncing}
                        />
                    )}
                </div>
            )}
            {props.isGroupTable && (
                <div className="relative">
                    <Button
                        className="max-w-32 px-2 !min-h-[30px] !py-0.5"
                        priorityType={UIPriority.SECONDARY}
                        uiSize="compact"
                        onClick={props.onExportProductsCsv}
                        disabled={props.isExportLoading}
                    >
                        {props.isExportLoading ? 'Экспорт...' : 'Экспорт'}
                    </Button>
                    {!!props.groupsExportCount && (
                        <div
                            className={`absolute right-0 top-0 flex h-4 -translate-y-[20%] items-center justify-center rounded-full bg-blue-600 text-[9px] text-white ${props.groupsExportCountBadgeClassName}`}
                        >
                            <span>{props.groupsExportCount}</span>
                        </div>
                    )}
                </div>
            )}
            {(props.isReviewsTable || props.isGroupTable) && props.isExportLoading && (
                <Button
                    className="w-32 max-w-32 whitespace-nowrap !min-h-[30px] !p-[5px] disabled:opacity-50"
                    priorityType={UIPriority.SECONDARY}
                    uiSize="compact"
                    onClick={props.onCancelExport}
                >
                    Отмена экспорта
                </Button>
            )}
        </>
    );
};
